module.exports = __webpack_public_path__ + "img/shopee-admin-icons.2079e1ba.svg";